import { useLocation } from 'react-router-dom';

// 读取当前用户菜单权限，判断当前页面是否可编辑
export function useMenuPermission() {
  const location = useLocation();

  const user = (() => {
    try {
      const stored = localStorage.getItem('user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  })();

  const isSuperAdmin = user?.username === 'admin';
  const menuPermissions = user?.menu_permissions || [];

  // 判断指定菜单是否可编辑
  const isMenuEditable = (path) => {
    if (isSuperAdmin) return true;
    const perm = menuPermissions.find(p => p.key === path);
    return perm ? perm.is_editable === 1 : false;
  };

  // 获取当前页面路径对应的菜单 key
  const pathname = location.pathname;

  // 查找当前路径匹配的菜单权限
  // 精确匹配 /orders，前缀匹配 /orders/123
  const findMenuKey = (path) => {
    // 精确匹配
    const exact = menuPermissions.find(p => p.key === path);
    if (exact) return exact.key;
    // 前缀匹配（如 /orders/123 匹配 /orders）
    const prefix = menuPermissions.find(p => path.startsWith(p.key + '/') || (p.key === '/orders' && path.startsWith('/orders/')));
    return prefix?.key;
  };

  const currentMenuKey = findMenuKey(pathname);
  const canEdit = isSuperAdmin || (currentMenuKey ? isMenuEditable(currentMenuKey) : true);

  return { canEdit, isSuperAdmin, currentMenuKey, menuPermissions };
}
